import { BasicService } from "./core/basic.service";

export class WebsiteService extends BasicService {
  //轮播图
  static async getList(query) {
    const data = await this.http.post('/slide/index',query);
    data.data.forEach(item => {
      if(item.is_enable === 1)item.is_enable = true
      else item.is_enable = false
    });
    return Promise.resolve(data.data);
  }
  static async getListDetail(id) {
    const data = await this.http.post('/slide/detail',{ id })
    data.is_enable = !!data.is_enable;
    return Promise.resolve(data)
  }
  static switchRoleStatus(id, is_enable) {
    return this.http.post('/slide/StatusUpdate', { id, is_enable } )
  }
  static async upload(query) {
    const data = await this.http.post('/File_logic/upload',query);
    return Promise.resolve(data);
  }
  static async submitRotationChart(query) {
    const data = await this.http.post('/slide/save',query);
    return Promise.resolve(data);
  }
  static async delectRotationChart(query) {
    const data = await this.http.post('/slide/del',{id: query});
    return Promise.resolve(data)
  }
  //自定义页面
  static async getListByCustomPage(pageOption,val,id) {
    const data = await this.http.post('/custom_view/customViewList',{...pageOption,...val,id});
    if(id){
      return Promise.resolve(data)}
    else{
      data.list.forEach(item => {
        item.is_enable = !!item.is_enable;
        item.is_header = !!item.is_header;
        item.is_footer  = !!item.is_footer ;
        item.is_full_screen = !!item.is_full_screen;
        item.name = item.title
        item.value = item.id
      });
    }
    return Promise.resolve(data.list)
    
    
  }
  static async switchCustomPageStatus(id,tag) {
    await this.http.post('/custom_view/showSwitch',{ id:id, tag:tag })
  }
  static async submitcustomView(query) {
    const data = await this.http.post('/custom_view/customViewSave',query);
    return Promise.resolve(data)
  }
  //地区管理
  static async getListByRegion() {
    const data = await this.http.post('/region/index')
    data.forEach(item => {
      item.is_enable = !!item.is_enable;
    })
    return Promise.resolve(data)
  }
  static async getNodeSon(id) {
    const data = await this.http.post('/region/getnodeson',{id: id})
    data.forEach(item=> {
      item.is_enable = !! item.is_enable
    })
    return Promise.resolve(data)
  }
  static async saveRegion(query) {
    const data = await this.http.post('/region/save',query)
    return Promise.resolve(data)
  }
  static async switchRegionStatus(id,is_enable) {
    const data = await this.http.post('/region/StatusUpdate',{ id, is_enable })
    return Promise.resolve(data)
  }
  static async delRegion(id) {
    const data = await this.http.post('/region/del',{id})
    return Promise.resolve(data)
  }
  //筛选价格
  static async getPrice() {
    const data = await this.http.post('/Screening_price/index')
    data.forEach(item=> {
      item.is_enable = !! item.is_enable
    })
    return Promise.resolve(data)
  }
  static async getPriceDetail(id) {
    const data = await this.http.post('/Screening_price/detail', {id})
    data.is_enable = !! data.is_enable
    return Promise.resolve(data)
  }
  static async saveScreening_price(query) {
    const data = await this.http.post('/Screening_price/save',query)
    return Promise.resolve(data)
  }
  static async delScreening_price(id) {
    const data = await this.http.post('/Screening_price/del',{id})
    return Promise.resolve(data)
  }
  static async swichScreening_priceStatus(id,is_enable) {
    const data = await this.http.post('/Screening_price/statusUpdate',{ id, is_enable })
    return Promise.resolve(data)
  }
  //快递管理
  static async getShippingList(pageOption,name) {
    const data = await this.http.post('/shipping/getList',{ ...pageOption,...name})
    data.data.forEach(item=> {
      item.is_enable = !! item.is_enable
    })
    return Promise.resolve(data)
  }
  static async getShippingListDetail(shipping_id) {
    const data = await this.http.post('/shipping/detail', {shipping_id})
    data.is_enable = !! data.is_enable
    return Promise.resolve(data)
  }
  static async switchShippingStatus(shipping_id,is_enable) {
    const data = await this.http.post('/shipping/StatusUpdate',{ shipping_id, is_enable })
    return Promise.resolve(data)
  }
  static async delShipping(shipping_id) {
    const data = await this.http.post('/shipping/del',{shipping_id})
    return Promise.resolve(data)
  }
  static async submitShipping(query) {
    const data = await this.http.post('/shipping/save', query)
    return Promise.resolve(data)
  }
  //导航管理
  static async getNavigationList() {
    function is_show (item){
      item.forEach(item=> {
        item.is_show = !!item.is_show
        if(item.child){
          is_show(item.child)
        }
      })
    }
    const data = await this.http.post('/navigation/navigationList')
    is_show(data.header)
    is_show(data.middle)
    is_show(data.footer)
    return Promise.resolve(data)
    // let dataHeader = data.header
    // let dataMiddle = data.middle
    // let dataFooter = data.footer
    // if(type === 'all'){
    //   Array.prototype.push.apply(dataHeader, dataMiddle)
    //   Array.prototype.push.apply(dataHeader, dataFooter)
    //   is_show(dataHeader)
    //   dataHeader.data_type = data.data_type
    //   return Promise.resolve(dataHeader)
    // }else if(type === 'header') {
    //   is_show(dataHeader)
    //   return Promise.resolve(dataHeader)
    // }else if(type === 'middle') {
    //   is_show(dataMiddle)
    //   dataMiddle.data_type = data.data_type
    //   return Promise.resolve(dataMiddle)
    // }else if(type === 'footer') {
    //   is_show(dataFooter)
    //   dataFooter.data_type = data.data_type
    //   return Promise.resolve(dataFooter)
    // }
    
    
  }
  static async getNavigationListDetail(id) {
    const data = await this.http.post('/navigation/navigationList',{id})
    data.is_show = !! data.is_show
    return Promise.resolve(data)
  }
  static async switchNavigationStatus(id,is_show) {
    const data = await this.http.post('/navigation/showSwitch',{ id, is_show })
    return Promise.resolve(data)
  }
  static async delNavigation(id) {
    const data = await this.http.post('/navigation/navigationDel',{id})
    return Promise.resolve(data)
  }
  static async submitNavigation(query) {
    const data = await this.http.post('/navigation/navigationSave',query)
    return Promise.resolve(data)
  }
}


